import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { concatAll, map, toArray } from 'rxjs/operators';
import { Authorisation } from '../api/src/app/models/REGBP-V1.0.0/authorisation.model';
import { LitigationMotive } from '../api/src/app/models/REGBP-V1.0.0/litigation-motive.model';

@Injectable({
  providedIn: 'root'
})
export class LitigationMotivesFacade {
  constructor(public regbpService: RegbpService) {}

  public getLitigationMotives(language: string): Observable<LitigationMotive[]> {
    return this.regbpService.getLitigationMotiveList(language).pipe(
      map((results: any) => results.$response.body.items),
      concatAll(),
      map((litigationMotive: LitigationMotive) => {
        return litigationMotive;
      }),
      toArray()
    );
  }
}
